import React, { useState } from 'react';
import { Footer } from './PageFooter';
import { Header } from './header';
// tslint:disable-next-line: no-submodule-imports
import 'bootstrap/dist/css/bootstrap.min.css';
import "./layout.less";
import { BulletItem } from '../components/SubpageComponents';
import useScrollPosition from '@react-hook/window-scroll';
import { WDBLogo, PhoneIcon, AddressIcon, ScrollUpIcon, ContactIcon, MailIcon } from './svg/Icons';
import { envBrandPZlow, helpMail, helpPhone1, helpPhone2 } from '../model/Const';
import { prettyPrintPLPhoneNumber } from '../common/utl/PhoneNumberUtils';
import CookieConsent from 'react-cookie-consent';
import { Button } from 'react-bootstrap';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import MomentUtils from '@date-io/moment';
import moment from 'moment';
import 'moment/locale/pl';
import { AffiliateLink } from './AffiliateLink';

moment.locale("pl");

export const PageLayout: React.FunctionComponent<{}> = ({ children }) => (
  <>
    <MuiPickersUtilsProvider utils={MomentUtils} locale="pl">
      <div id="pageTop"></div>
      <div className="pb-3 header-line only-desktop">
        <div className="d-flex flex-column align-items-center">
          <div className="d-flex justify-content-between px-5 mt-3 only-desktop w-100" style={{ maxWidth: 1460 }}>
            {envBrandPZlow &&
              <a href={"https://www.pzlow.pl/"}>
                <div className="align-self-start">
                  <img src="/img/pzlow/logo_pzlow.webp" style={{ width: 'auto', height: 60 }} />
                </div>
              </a>
            }
            <div className="d-flex">
              <AffiliateLink to={"/#o-fundacji"}>
                <div className="mr-5"><img src="/img/logo_fundacji.png" style={{ width: 'auto', height: 42 }} /></div>
              </AffiliateLink>
              <AffiliateLink to={"/#o-wdb"}>
                {envBrandPZlow &&
                  <div className="mr-3"><WDBLogo style={{ width: 'auto', height: 45 }} /></div>
                }
                {!envBrandPZlow &&
                  <div className="mr-5"><WDBLogo style={{ width: 'auto', height: 45 }} /></div>
                }
              </AffiliateLink>
            </div>
            <div className="d-flex fw-500">
              <div className="d-flex align-self-start">
                <div className="mr-2 align-self-end pb-1">
                  <PhoneIcon style={{ width: 24, height: 24, fill: 'var(--yellow-color)' }} />
                </div>
                <div className="align-self-end">
                  <a
                    href={'tel:' + helpPhone1}
                  >
                    {prettyPrintPLPhoneNumber(helpPhone1)}
                  </a>
                  <br />
                  <a
                    href={'tel:' + helpPhone2}
                  >
                    {prettyPrintPLPhoneNumber(helpPhone2)}
                  </a>
                </div>
              </div>
              <div className="d-flex align-self-start">
                <div className="d-flex flex-column align-items-end">
                  <span>
                    WDB S.A.
                  </span>
                  <div className="d-flex">
                    <div className="ml-3">
                      <MailIcon style={{ width: 24, height: 24, fill: 'var(--yellow-color)' }} />
                      <a
                        className="ml-2"
                        href={'mailto:' + helpMail}
                      >
                        {helpMail}
                      </a>
                    </div>

                  </div>
                </div>
              </div>

              <div className="d-flex align-self-start ml-4">
                <div className="mr-2 align-self-end pb-1">
                  <AddressIcon style={{ width: 18, height: 'auto', fill: 'var(--yellow-color)' }} />
                </div>
                <div className="d-flex flex-column align-items-end">
                  <span>
                    ul. Fiołkowa 3
                  </span>
                  <span>
                    52 -200 Wysoka
                  </span>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>

      <Header />

      <div className="d-flex flex-column align-items-center">
        <div className="d-flex flex-column w-100">
          <main style={{ flexGrow: 1 }} >
            {children}
          </main>
        </div>
      </div>
      <Footer />
      <BackToTop />
      <Cookies />
    </MuiPickersUtilsProvider>
  </>
);

function Cookies()
{
  const [isOpen, setOpen] = useState(false);

  return (
    <CookieConsent
      buttonId="cookie"
      location="bottom"
      buttonText="Tak, rozumiem."
      disableStyles={true}
      disableButtonStyles={true}
      style={{
        background: "#2B373B",
        position: 'sticky',
        padding: '10px',
        display: 'block',
        color: 'white'
      }}
      buttonStyle={{
        backgroundColor: 'var(--yellow-color)',
        fontSize: "16px", fontWeight: 700,
        padding: '10px 20px', borderRadius: '24px',
        color: '#464748',
        border: 'none',
      }}
      expires={731}
      sameSite="strict"
    >
      <div className="my-3 fs-14">
        <div>
          W celu zapewnienia prawidłowego działania niniejszego serwisu niezbędnym jest wykorzystanie plików cookie,
          jednak nie musisz się na to zgadzać.
          Kliknij
          <Button
            id="cookieMore"
            variant="link"
            className="ml-1 p-0"
            onClick={() => setOpen(true)}
          >
            <span className="text-yellow">
              tutaj
            </span>
          </Button>, aby dowiedzieć się:
        </div>
        <BulletItem className="mt-3">
          jakie pliki cookie wykorzystujemy i w jakim celu to robimy,
        </BulletItem>
        <BulletItem className="mt-1">
          co zrobić, gdy nie zgadzasz się na wykorzystanie plików cookie.
        </BulletItem>
        <br />
        {isOpen &&
          <div>
            <div>
              1. Portal wykorzystuje pliki cookie. Są to krótkie pliki tekstowe, zawierające informacje, zapisywane w systemie informatycznym Użytkownika a możliwe do odczytania przez Spółkę. Pliki te pozwalają na późniejszą identyfikację Użytkownika w razie ponownego połączenia z urządzeniem, na którym zostały zapisane.
            </div>
            <div className="mt-3">
              2. Cookies są wykorzystywane przez Spółkę w następujących celach: dla ułatwienia Użytkownikowi korzystania z zasobów udostępnianych przez Spółkę, w celu dostosowania wyglądu Portalu do oczekiwań i potrzeb konkretnego Użytkownika (tzw. personalizacja), w celu monitorowania ruchu w ramach Portalu, w tym porównania częstotliwości korzystania z określonych zasobów przez Użytkowników.
            </div>
            <div className="mt-3">
              3. Niektóre pliki cookie mogą być niezbędne do korzystania z usług jak i prawidłowego działania Portalu, dlatego wprowadzenie przez Użytkownika ograniczeń co do plików cookie (np. ich zablokowanie lub usunięcie) może spowodować nieprawidłowe funkcjonowanie Portalu na urządzeniach użytkownika.
            </div>
            <div className="mt-3">
              4. Mimo, że są one niezbędne dla prawidłowego działania strony a brak możliwości ich wykorzystania może uniemożliwić korzystanie z Portalu, każdy użytkownik może nie zgodzić się na wykorzystanie tych plików i ma możliwość zmodyfikowania warunków przechowywania (w tym także ograniczenia lub uniemożliwienia) bądź uzyskiwania dostępu; w tym celu należy skorzystać z odpowiedniej opcji używanego oprogramowania według wskazówek poniższych.
            </div>
            <div className="my-3">
              <BulletItem className="mt-3 align-items-baseline">
                Google Chrome
                <div className="mt-2">
                  Menu &gt; Ustawienia &gt; Pokaż ustawienia zaawansowane &gt; Prywatność &gt; Ustawienia treści &gt; Pliki cookies – należy wybrać odpowiednią opcję.
                </div>
              </BulletItem>
            </div>
            <div className="my-3">
              <BulletItem className="mt-3 align-items-baseline">
                Mozilla Firefox
                <div className="mt-2">
                  Menu &gt; Opcje &gt; Prywatność &gt; Historia – należy wybrać odpowiednią opcję.
                </div>
              </BulletItem>
            </div>
            <div className="my-3">
              <BulletItem className="mt-3 align-items-baseline">
                Opera
                <div className="mt-2">
                  Menu &gt; Preferencje &gt; Zaawansowane &gt; Ciasteczka – należy wybrać odpowiednią opcję.
                </div>
              </BulletItem>
            </div>
            <div className="my-3">
              <BulletItem className="mt-3 align-items-baseline">
                Safari
                <div className="mt-2">
                  Menu &gt; Preferencje &gt; Prywatność &gt; Pliki cookies – należy wybrać odpowiednią opcję.
                </div>
              </BulletItem>
            </div>
            <div className="mt-3">
              5. W Portalu mogą znajdować się przekierowania do innych serwisów internetowych będących własnością innych podmiotów, np..: Facebook, Instagram, Google+, YouTube czy Twitter. Serwisy te mają własne zasady dotyczące prywatności jak i plików cookie. Dlatego przed skorzystaniem z tych stron zaleca się, aby Użytkownik zapoznał się z panującymi tam zasadami dotyczącymi ochrony danych osobowych czy wykorzystywaniem plików cookie.
            </div>

          </div>}
      </div>
    </CookieConsent>
  );
}

function BackToTop()
{
  const scrollPos = useScrollPosition();

  if (scrollPos <= 0)
  {
    return null;
  }

  return <div
    style={{
      position: 'fixed',
      right: 20,
      bottom: 20,
      display: 'flex',
    }}
  >
    <a href={'tel:' + helpPhone1}>
      <ContactIcon style={{ width: 65.38, height: 60.7 }} />
    </a>

    <a href="#pageTop" className="ml-3">
      <ScrollUpIcon style={{ width: 48, height: 48 }} />
    </a>
  </div>;
}
